module.exports = __webpack_public_path__ + "media/images/flags/16/Palau-dc30a400cdf2f08d66252aeb6b4ba3f3.png";